import React, { useEffect, useState } from "react";

import { Close } from "@mui/icons-material";

import { IAlertCard } from "./interface";
import { Container, Content, TitleContainer } from "./styles";

const SimpleToast: React.FC<IAlertCard> = ({
  id,
  type,
  title,
  description,
  timeLimitToast = 4000,
  directionHorizontal = "Right",
  directionVertical = "Top",
  trigger,
  handleCloseToast,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (trigger > 0) {
      setShow(true);
      setTimeout(() => {
        closeToast();
        setShow(false);
      }, timeLimitToast);
    }
  }, [trigger]);

  const closeToast = () => {
    handleCloseToast(id);
  };

  return (
    <>
      {show ? (
        <Container
          id="toast"
          type={type}
          directionHorizontal={directionHorizontal}
          directionVertical={directionVertical}
        >
          <Content>
            <TitleContainer>
              <strong>{title}</strong>
              <Close onClick={() => setShow(false)} />
            </TitleContainer>
            {description && <span>{description}</span>}
          </Content>
        </Container>
      ) : null}
    </>
  );
};

export default SimpleToast;
